import { createTheme } from '@mui/material/styles';
import { themeConfig, getThemeOverrides } from './themeConfig';

// Define common theme settings
const commonSettings = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        },
      },
    },
  },
};

// Create light theme
export const lightTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'light',
    primary: themeConfig.primary,
    secondary: themeConfig.secondary,
    success: {
      main: themeConfig.success.main,
      light: themeConfig.success.light,
      dark: themeConfig.success.dark,
    },
    error: themeConfig.error,
    warning: themeConfig.warning,
    info: themeConfig.info,
    background: themeConfig.background,
    text: themeConfig.text,
  },
  ...getThemeOverrides(),
});

// Create dark theme
export const darkTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  components: {
    ...commonSettings.components,
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          ...commonSettings.components.MuiCssBaseline.styleOverrides.body,
          '&::-webkit-scrollbar-track': {
            background: '#2e2e2e',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#6b6b6b',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#8a8a8a',
          },
        },
      },
    },
  },
});

const themes = {
  light: lightTheme,
  dark: darkTheme,
};

export default themes; 